module.exports = __webpack_public_path__ + "img/sc.4b171687.svg";